var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCompass24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.422 7.314-4.771 2.18c-.248.113-.544.409-.658.657l-2.18 4.77c-.513 1.124.644 2.28 1.767 1.768l4.77-2.18c.248-.113.543-.41.657-.657l2.18-4.77c.514-1.16-.645-2.28-1.765-1.768Zm-1.98 5.63a1.333 1.333 0 1 1-1.885-1.885 1.333 1.333 0 0 1 1.885 1.884Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeWidth: 2
  })));
});
SvgCompass24.displayName = "SvgCompass24";
export default SvgCompass24;